import { forwardRef } from 'react';
import { css } from '@emotion/react';
import type { PpWC } from '@noah-labs/fe-shared-ui-shared';
import { LocalizedLink } from 'gatsby-theme-i18n';

type PpLocalizedLinkWithRef = PpWC & {
  href: string;
  language: string;
  onClick?: () => void;
};

const styles = {
  localizedLink: css`
    text-decoration: none;
    color: inherit;
  `,
};

export const LocalizedLinkWithRef = forwardRef(
  ({ children, href, language, onClick, ...rest }: PpLocalizedLinkWithRef, ref) => (
    <LocalizedLink
      innerRef={ref}
      language={language}
      {...rest}
      css={styles.localizedLink}
      to={href}
      onClick={onClick}
    >
      {children}
    </LocalizedLink>
  ),
);

LocalizedLinkWithRef.displayName = LocalizedLinkWithRef.name;
